export default "__VITE_PUBLIC_ASSET__30975afe__"